import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_AvZRhVsu6tNH: {
	id: 'prd_AvZRh2DEV2Vsu6tNH'
	ident: 'prd_AvZRhVsu6tNH'
	sku: 'simple_premium_4w_8_79_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_eLNhf2DEV2en3zL9x'
			amount: 44
			amount_usd: 8.79
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 8.79
			discount: 35.21
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_9bQXq2DEV21Efm1fS'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_AvZRhVsu6tNH, SubscriptionProduct>
const prd_AvZRhVsu6tNH = { ident: 'prd_AvZRhVsu6tNH' } as typeof _prd_AvZRhVsu6tNH

export default prd_AvZRhVsu6tNH
